// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-overlay-wrapper {
  position: relative;
}

.form-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.6);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.form-overlay-fieldset {
  border: none;
  margin: 0;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/myComponents/FormSubmitOverlay/FormSubmitOverlay.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;AACD;;AAEA;EACC,kBAAA;EACA,QAAA;EACA,oCAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACD;;AAEA;EACC,YAAA;EACA,SAAA;EACA,UAAA;AACD","sourcesContent":[".form-overlay-wrapper {\n\tposition: relative;\n}\n\n.form-overlay {\n\tposition: absolute;\n\tinset: 0;\n\tbackground: rgba(255, 255, 255, 0.6);\n\tz-index: 10;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 4px;\n}\n\n.form-overlay-fieldset {\n\tborder: none;\n\tmargin: 0;\n\tpadding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
